import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { to_query } from 'components/pages/filter-transformer';
import { TaskField } from 'stores/fields';
import { constructTaskFilterUrl } from '../../../utils/construct-task-filter-url';
import { getTasksAtRiskFilter } from './use-tasks-at-risk';

export const Title: FC<{
  projectId: number;
  taskFields: Record<string, TaskField>;
}> = ({ projectId, taskFields }) => {
  const queryParams = to_query(getTasksAtRiskFilter(taskFields));

  return (
    <Row>
      <Col flex={1}>
        <strong>
          <FormattedMessage id="project.overview.tasks_at_risk.title" />
        </strong>
      </Col>
      <a
        href={constructTaskFilterUrl(projectId, queryParams)}
        target="_blank"
        rel="noopener noreferrer"
        data-cy="view.tasks.at.risk-button.cta"
      >
        <FormattedMessage id="view_all" />
      </a>
    </Row>
  );
};
